import Vue from 'vue';
import PendingOperation from "@/utils/PendingOperation.vue";
import NumberInput from "@/components/inputs/NumberInput.vue";

Vue.component('PendingOperation', PendingOperation);
Vue.component('NumberInput', NumberInput);